import {ChangeDetectionStrategy, Component, InputSignal, input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormTimeComponent} from '../../../../shared/elements/form-time/form-time.component';
import {TranslatePipe} from '../../../../shared/pipes/translate.pipe';
import {FeedbackStructureQuestionFormQuestion} from '../../feedback-structure-create-update-dialog/feedback-structure-question/feedback-structure-question-form.model';
import {feedbackAnswerControlName} from '../../helpers/feedback-structure-preview-control-names';

@Component({
	selector: 'app-feedback-form-element-time',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [FormTimeComponent, TranslatePipe],
	template: `
		<div class="ps-md-3">
			<app-form-time
				[fG]="formGroup()"
				[fCN]="answerControlName()"
				[placeholder]="'FEEDBACKQUESTIONTYPETIME' | translate"
				[errorText]="'INPUTREQUIRED' | translate"
				[hasErrorField]="true"
				[disabled]="disabled()"
			></app-form-time>
		</div>
	`,
})
export class FeedbackFormElementTimeComponent {
	public question: InputSignal<FeedbackStructureQuestionFormQuestion> = input.required();
	public formGroup: InputSignal<FormGroup> = input.required();
	public controlNamePrefix: InputSignal<string> = input('preview');
	public disabled: InputSignal<boolean> = input(false);

	public answerControlName(): string {
		return feedbackAnswerControlName(this.question(), this.controlNamePrefix());
	}
}
